import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-support',
  templateUrl: './user-support.component.html',
  styleUrls: ['./user-support.component.scss']
})
export class UserSupportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
